import { Injectable } from '@angular/core';
import { ParseAPIService, DbObjectsStore } from '../abstract/ParseAPIService';
import { Damage, DamageAnalysis, ModelIa, RoiAnalysis } from '../model/damage.model';
import { Roi as RoiParse } from '../model/damage.model';
import 'parse';
import { RoiService, VehiclePart } from './roi.service';
import { environment } from '../../environments/environment';
import { TchekImage, TchekImageUrl } from '../model/image';
import { AwsService } from './aws.service';
import { Subject } from 'rxjs';
import { Roi } from '../model/roi'
import { Roi as RoiD } from '../model/damage.model'
import { from } from 'rxjs/observable/from';
import { Tchek } from '../model/tchek';
import { FolderService } from './folder.service';
import { ParametersService } from './parameters.service';
import { SearchService } from './search.service';
import { SubscriptionService } from './subscription.service';
import { DamageVehicle } from '../model/damageVehicle.model';
import { LocalstorageService } from './localstorage.service';
import { ParseFunctionService } from './parsefunction.service';
import { ClassificationService } from './classification.service';
import { SearchTagCheckbox } from '../model/search';
import { DamageFilterService } from '../damage-filter.service';
import { TchekType } from '../model/tchekb.model';
import { ImagesService } from './images.service';
import { Ng2ImgMaxService } from 'ng2-img-max';
import { ToastService } from './toast.service';
const parse: typeof Parse = require('parse');
const parse2: typeof Parse = require('parse');
@Injectable()
export class DamageService implements ParseAPIService<Damage> {

  public openLocations: string[] = []
  public offsetScroll: number = 0
  public tchekId: string
  public allOpenLocations: boolean = false

  public partsInRightTchekSvg: string[];
  public sortArray: string[];
  store: DbObjectsStore<Damage>;

  private selectRoi = new Subject<{ image: string, folder: string }>();
  selectRoiObs = this.selectRoi.asObservable();
  setSelectRoi(data) {
    this.selectRoi.next(data)
  }

  private comparison = new Subject<any>();
  comparisonObs = this.comparison.asObservable();
  setComparison(active: boolean) {
    this.comparison.next(active)
  }

  private openmodal = new Subject<any>();
  openmodalObs = this.openmodal.asObservable();
  modalOpen(data?: any) {
    this.openmodal.next(data)
  }

  private createroi = new Subject<any>();
  createroiObs = this.createroi.asObservable();
  roiCreated(data?: any) {
    this.createroi.next(data)
  }

  private deleteroi = new Subject<any>();
  deleteroiObs = this.deleteroi.asObservable();
  roiDeleted(data?: any) {
    this.deleteroi.next(data)
  }
  constructor(
    private readonly _roiService: RoiService,
    private readonly _subscriptionService: SubscriptionService,
    private _awsService: AwsService,
    private _imageService: ImagesService,
    private ng2ImgMaxService: Ng2ImgMaxService,
    private readonly _classificationService: ClassificationService,
    private readonly _folderService: FolderService,
    private readonly _parametersService: ParametersService,
    private readonly _parseFunctionService: ParseFunctionService,
    private readonly _damageFilterService: DamageFilterService,
    private readonly _toastService: ToastService,
  ) {

    this.store = {};
    this.partsInRightTchekSvg = [
      'OPTARD', 'OPTARG', 'ABRARD', 'ABRARG', 'PNEARD', 'CFR', 'ROUARD',
      'ROUAVD', 'PNEAVD', 'JNTARD', 'JNTAVD', 'PRCAR', 'JUPAR',
      'PHRARD', 'PHRARG', 'BGFD', 'VTRAVD', 'VTRARD', 'CSTAVD', 'CSTARD',
      'PGNAVD', 'PGNARD', 'GLCD', 'RTRD', 'COQD', 'RPTD', 'MNPAVD', 'MNPARD',
      'BDPAVD', 'BDPARD', 'MNTD', 'PLI', 'INS', 'PVN', 'FPSARG', 'FPSARD',
      'AILAVD', 'AILARD', 'PRTAVD', 'PRTARD', 'PRBAR', 'BDCD'
    ];

    this.sortArray = [
      'AILAVG', 'JNTAVG', 'PNEAVG', 'ROUAVG', 'RTRG', 'PRTAVG', 'PGNAVG', 'VTRAVG',
      'PRTARG', 'PGNARG', 'VTRARG', 'CSTARG', 'PNEARG', 'JNTARG', 'ROUARG', 'AILARG', 'TRP', 'BDCG',
      'OPTARG', 'PRCAR', 'CFR', 'PRBAR', 'OPTARD', 'PNEARD', 'JNTARD', 'ROUARD', 'AILARD', 'CSTARD',
      'PRTARD', 'PGNARD', 'VTRARD', 'PRTAVD', 'PGNAVD', 'VTRAVD', 'RTRD', 'PNEAVD', 'JNTAVD', 'ROUAVD',
      'AILAVD', 'BDCD', 'PRCAV', 'ABRAVD', 'ABRAVG', 'OPTAVD', 'CLR', 'OPTAVG',
      'CPT', 'PRBAV', 'TOI'];
  }

  public getSortArray(sens: string): string[] {
    console.log('sens de rotation : ', sens);
    let array = this.sortArray.slice()
    if (typeof sens !== 'string') return array.concat(['unknow'])
    if (sens === 'counterclockwise')
      return array.concat(['unknow'])
    else
      return array.reverse().concat(['unknow'])
  }



  public saveRoi(data) {
    this._toastService.toastOpen(true)
    const roi = new Roi();
    if (data.currentMode === 'video') {
      roi.folderPtr = data.listAnimation.get(data.cameraNumber).folderId;
      roi.folder = data.listAnimation.get(data.cameraNumber).folder;
      roi.picture = data.picture;
    } else {
      roi.imageId = data.modalData.imagePtr.id;
    }
    roi.centerX = data.cirlcleCenterX
    roi.centerY = data.cirlcleCenterY
    roi.radius = data.cirlcleRadius
    roi.tchek = new Tchek(data.tchekId);
    roi.type = data.modalData.selectedType;
    roi.location = data.modalData.selectedLocation;
    roi.severity = data.modalData.selectedSeverity;
    roi.toSync = true;
    roi.width = data.circle.width;
    roi.height = data.circle.height;
    roi.vehicleId = data.vehicleId;
    roi.costType = data.modalData.selectedCostType;
    roi.cost = data.modalData.selectedCost;
    // console.log('saving ', roi);
    if (this._parametersService.isSuperAdmin) {
      roi.isAuto = data.modalData.isROIAuto;
    } else {
      roi.isAuto = false;
    }
    // Adding folderPtr
    // this._folderService.getByTchek(data.tchekId).then(folders => {
    //   roi.folderPtr = folders.find(f => f.name === roi.folder).getParseInstance();
    // });

    // Saving ROI
    this._roiService.setPictureRoi(roi).then(
      async (savedDamage: Parse.Object) => {
        let count = 0
        this.ng2ImgMaxService.compress(data.modalData.images, 0.7, false, false).subscribe((result) => {
          let reader = new FileReader();
          reader.readAsDataURL(result);
          reader.onloadend = (() => {
            var b64 = reader.result.toString()
            this.getImageDimensions(b64).then((size: { width: number, height: number }) => {
              let file = b64.replace(/^data:.+;base64,/, '');
              this._imageService.saveImages(file, data.tchekId, size, savedDamage.id).then((imagePtr) => {
                // here create one new roi foreach picture file
                console.log('create roi for image ptr');
                this._roiService.createNewRoi(roi, imagePtr.id, savedDamage.id).then(roiR => {
                  console.log('new file roi ', roiR);
                  data.rois.array.push(roiR)
                  count++
                  if (data.modalData.images.length === count) {
                    this.roiCreated(data);
                    this._toastService.toastOpen(false)
                  }
                })
              })
            })
          }).bind(this);
        })

        savedDamage.get('roiPtr').fetchWithInclude(['tchekPtr', 'damagePtr', 'folderPtr'])
          .then((fetchedRoi: Parse.Object) => {
            data.rois.array.push(fetchedRoi);
            if (data.modalData.images === undefined || data.modalData.images.length <= 0) {
              this.roiCreated(data);
              this._toastService.toastOpen(false)
              //this.renderCanvas(listAnimation.get(cameraNumber).currentPicture);
            }
          });
        this.reloadDamages = true
      },
      error => {
        console.error('Cannot save ROI to Parse ', error);
      }
    );
  }

  public saveRoiFile(data: DamageAnalysis, files) {
    let thos = this
    return new Promise(function (resolve, reject) {
      const roi = new Roi();
      roi.folderPtr = data.roiPtr.folderPtr.id
      roi.folder = data.roiPtr.folder
      roi.picture = data.roiPtr.picture
      roi.centerX = data.roiPtr.centerX
      roi.centerY = data.roiPtr.centerY
      roi.radius = data.roiPtr.radius
      roi.tchek = new Tchek(data.roiPtr.tchekPtr.id);
      roi.type = data.type
      roi.location = data.location
      roi.severity = data.severity
      roi.toSync = true;
      roi.width = data.roiPtr.width
      roi.height = data.roiPtr.height;
      roi.vehicleId = data.tchekPtr.vehiclePtr.id;
      roi.costType = data.costType;
      roi.cost = data.count;
      // console.log('saving ', roi);
      if (thos._parametersService.isSuperAdmin) {
        roi.isAuto = data.isAuto;
      } else {
        roi.isAuto = false;
      }
      // Adding folderPtr
      // this._folderService.getByTchek(data.tchekId).then(folders => {
      //   roi.folderPtr = folders.find(f => f.name === roi.folder).getParseInstance();
      // });

      // Saving ROI
      let count = 0
      thos.ng2ImgMaxService.compress(files, 0.7, false, false).subscribe((result) => {
        let reader = new FileReader();
        reader.readAsDataURL(result);
        reader.onloadend = (() => {
          var b64 = reader.result.toString()
          thos.getImageDimensions(b64).then((size: { width: number, height: number }) => {
            let file = b64.replace(/^data:.+;base64,/, '');
            thos._imageService.saveImages(file, data.tchekPtr.id, size, data.id).then((imagePtr) => {
              // here create one new roi foreach picture file
              console.log('create roi for image ptr');
              thos._roiService.createNewRoi(roi, imagePtr.id, data.id).then(roiR => {
                console.log('new file roi ', roiR);
                data.listRoi.push(new RoiAnalysis(new RoiParse(roiR)))
                count++
                if (files.length === count) {
                  thos.reloadDamages = true
                  resolve(true)
                }
              })
            })
          })
        }).bind(this);
      })
    })
  }


  public cancelRoi = (data: any) => {
    data.fcanvas.fxRemove(data.circle);
    data.circle = undefined;
  };

  public async getAll(limit?: number): Promise<Damage[]> {
    const query = this.baseQuery();
    if (typeof limit === 'number')
      query.limit(limit);
    try {
      const foundObjects = await query.find();
      foundObjects.forEach(o => this.store[o.id] = new Damage(o));
      return Object.values(this.store);
    } catch (e) {
      console.error(e);
      return [];
    }
  }

  getImageDimensions(file) {
    return new Promise(function (resolved, rejected) {
      var i = new Image()
      i.onload = function () {
        resolved({ width: i.width, height: i.height })
      };
      i.src = file
    })
  }


  public async get(id: string): Promise<Damage> {
    const query = this.baseQuery();
    try {
      this.store[id] = new Damage(await query.get(id));
      return this.store[id];
    } catch (e) {
      console.error(e);
      return undefined;
    }
  }


  damagesMemory: { damageList: Damage[], tchekId: string, filter: boolean }
  reloadDamages: boolean = false
  public async getByTchek(id: string, filter: boolean = true): Promise<Damage[]> {
    if (this.damagesMemory && this.damagesMemory.tchekId
      && this.damagesMemory.tchekId === id && this.damagesMemory.filter === filter
      && this.reloadDamages === false) {
      return this.damagesMemory.damageList
    } else {
      const query = this.baseQuery();
      let tchek = {
        __type: "Pointer",
        className: "Tchek",
        objectId: id
      };
      try {
        this.reloadDamages = false
        let damagesFound: Damage[] = [];
        (await query.equalTo('tchekPtr', tchek).find())
          .forEach(d => {
            if (d.get('roiPtr')) {
              this.store[d.id] = new Damage(d);
              damagesFound.push(this.store[d.id]);
            }
          });

        if (this._classificationService.active)
          return damagesFound;

        damagesFound = await this._damageFilterService.applyFiltersIA(damagesFound, filter)
        this.damagesMemory = { damageList: damagesFound, tchekId: id, filter: filter }
        console.log(damagesFound);
        return damagesFound;
      } catch (e) {
        console.error(e);
        return undefined;
      }
    }
  }



  public async countByTchek(id: string): Promise<number> {
    const query = this.baseQuery();
    const tchek = new parse.Object('Tchek');

    let tchekPtr = {
      __type: "Pointer",
      className: "Tchek",
      objectId: id
    };
    tchek.id = id;
    try {
      //await tchek.fetch();
      return await query.equalTo('tchekPtr', tchekPtr).count();
    } catch (e) {
      console.error(e);
      return undefined;
    }
  }

  public async subscribeCountByTchek(id: string, plusOneHandler: Function,
    minusOneHandler: Function) {
    const tchek = new parse.Object('Tchek');
    tchek.id = id;
    try {
      await tchek.fetch();
    } catch (e) {
      console.error(e);
    }
    this._subscriptionService.sub(
      this.baseQuery().equalTo('tchekPtr', tchek), 'damagesCount');
    this._subscriptionService.listen('damagesCount', 'create', plusOneHandler);
    this._subscriptionService.listen('damagesCount', 'enter', plusOneHandler);
    this._subscriptionService.listen('damagesCount', 'leave', minusOneHandler);
    this._subscriptionService.listen('damagesCount', 'delete', minusOneHandler);
  }

  public unsubscribeCountByTchek() {
    this._subscriptionService.ignore('damagesCount', 'create');
    this._subscriptionService.ignore('damagesCount', 'enter');
    this._subscriptionService.ignore('damagesCount', 'leave');
    this._subscriptionService.ignore('damagesCount', 'delete');
    this._subscriptionService.unsub('damagesCount');
  }


  public async saveEditRoi(report: RoiParse | RoiParse[]): Promise<RoiParse | RoiParse[]> {
    if (Array.isArray(report)) {
      const array = report.map<Parse.Object>(r => r.getParseInstance());
      try {
        const savedObjects = await parse.Object.saveAll(array);
        const roilist = [];
        savedObjects.forEach(r => {
          roilist.push(new RoiParse(r));
        });
        return roilist;
      } catch (e) {
        console.error(e);
        return [];
      }
    } else {
      try {
        const savedObject = await report.getParseInstance().save();
        let roi = new RoiParse(savedObject);
        return roi;
      } catch (e) {
        console.error(e);
        return undefined;
      }
    }
  }

  public async save(report: Damage | Damage[]): Promise<Damage | Damage[]> {
    if (Array.isArray(report)) {
      const array = report.map<Parse.Object>(r => r.getParseInstance());
      try {
        const savedObjects = await parse.Object.saveAll(array);
        const damagesFound = [];
        savedObjects.forEach(d => {
          this.store[d.id] = new Damage(d);
          damagesFound.push(this.store[d.id]);
        });
        return damagesFound;
      } catch (e) {
        console.error(e);
        return [];
      }
    } else {
      try {
        if(report.tchekPtr.type ==4){
          let newD = await this.updateDamage(report)
          return  this.store[report.id]
        }else{
          const savedObject = await report.getParseInstance().save();
          this.store[savedObject.id] = new Damage(savedObject);
          return this.store[savedObject.id];
        }
      } catch (e) {
        console.error(e);
        return undefined;
      }
    }
  }

  public async delete(damage: Damage | Damage[]): Promise<Damage | Damage[]> {
    if (Array.isArray(damage)) {
      const array = damage.map<Parse.Object>(r => {
        r.isDeleted = true;
        r.toSync = true;
        return r.getParseInstance();
      });
      try {
        const deletedObjects = await parse.Object.saveAll(array);
        return deletedObjects.map<Damage>(o => new Damage(o));
      } catch (e) {
        console.error(e);
        return [];
      }
    } else {
      try {
        damage.toSync = true;
        damage.isDeleted = true;
        let newD = await this.deleteDamage(damage.id)
        //const deletedObject = await damage.getParseInstance().save();
        return// new Damage(deletedObject);
      } catch (e) {
        console.error(e);
        return undefined;
      }
    }
  }

  public async destroy(damage: Damage | Damage[]): Promise<Damage | Damage[]> {
    if (Array.isArray(damage)) {
      const array = damage.map<Parse.Object>(r => r.getParseInstance());
      try {
        const destroyedObjects = await parse.Object.destroyAll(array);
        return destroyedObjects.map<Damage>(o => new Damage(o));
      } catch (e) {
        console.error(e);
        return [];
      }
    } else {
      try {
        const destroyedObject = await damage.getParseInstance().destroy();
        return new Damage(destroyedObject);
      } catch (e) {
        console.error(e);
        return undefined;
      }
    }
  }

  public async toDamageAnalysisObject(damage: Damage, roiList: RoiAnalysis[]): Promise<DamageAnalysis> {
    let roi = damage.roiPtr
    const damageWithUrls = new DamageAnalysis(damage, roiList);
    console.log(damage, roi);
    if (roi.imagePtr !== undefined && roi.imagePtr.file !== undefined) {
      damageWithUrls.bestImageUrl = new TchekImageUrl({
        hd: roi.imagePtr.file.url(),
        mini: roi.imagePtr.file.url(),
        image: roi.imagePtr.id,
      })
      return damageWithUrls;
    } else if (roi.imagePtr !== undefined && roi.imagePtr.file === undefined && [4,5].includes(roi.tchekPtr.type)) {
      let index = this._roiService.imagesF.images.findIndex(f => { return f.id === roi.imagePtr.id })
      console.log(index);
      roi.imagePtr.file = this._roiService.parseFileObj(this._roiService.imagesF.images[index].url);
      damageWithUrls.bestImageUrl = new TchekImageUrl({
        hd: roi.imagePtr.file.url(),
        mini: roi.imagePtr.file.url(),
        image: roi.imagePtr.id,
      })
      return damageWithUrls;
    } else {
      if (!damage.roiPtr)
        throw new Error(`Damage ${damage.id} has no attribute roiPtr`);
      if (!damage.roiPtr.folderPtr)
        throw new Error(`ROI ${damage.roiPtr.id} has no attribute folderPtr`);

      const baseUrl = `${environment.isLocal ? damage.tchekPtr.devicePtr.webObjectId : damage.tchekPtr.devicePtr.id}/${damage.tchekPtr.path}`;
      const ipMachine = damage.tchekPtr.devicePtr.ipMachine
      const damageWithUrls = new DamageAnalysis(damage, roiList);

      damageWithUrls.imagesUrl.push(new TchekImageUrl({
        hd: `${baseUrl}/${roi.folder}/${roi.picture}.jpg`,
        mini: `${baseUrl}/mini/${roi.folder}/${roi.picture}.jpg`,
        camera: parseInt(roi.folder, 10),
        picture: roi.picture
      }));
      // Generating best image URL
      const cpPromises = [];
      cpPromises.push(this._awsService.generateUrlPromise(`${baseUrl}/${damage.roiPtr.folderPtr.name}/${damage.roiPtr.picture}.jpg`, ipMachine))
      cpPromises.push(this._awsService.generateUrlPromise(`${baseUrl}/mini/${damage.roiPtr.folderPtr.name}/${damage.roiPtr.picture}.jpg`, ipMachine))

      Promise.all(cpPromises).then(resolvedPromises => {
        // console.log('All promises resolutions :', resolvedPromises);
        // At this point, all media of all sizes have been loadedfolder
        damageWithUrls.bestImageUrl = new TchekImageUrl({
          hd: resolvedPromises[0],
          mini: resolvedPromises[1],
          camera: parseInt(damage.roiPtr.folder, 10),
          picture: damage.roiPtr.picture
        });

      })
      return damageWithUrls;
    }
  }

  private baseQuery(): Parse.Query {
    let canDetection = this._parametersService.canDetection;
    let activeRoiAdminDrawer = parse.User.current().get('companyPtr').get('settingsPtr').get("activeRoiAdminDrawer") ? parse.User.current().get('companyPtr').get('settingsPtr').get("activeRoiAdminDrawer") : false;
    let query = new parse.Query('Damage')
      .limit(1000)
      .include(['tchekPtr', 'roiPtr', 'roiPtr.folderPtr', 'parentPtr', 'parentPtr.tchekPtr', 'tchekPtr.vehiclePtr']);
    if (canDetection === false)
      query.notEqualTo('isAuto', true)
    if (activeRoiAdminDrawer !== true)
      query.notEqualTo('isDeleted', true)
    return query
  }

  async predictRepairCost(tchekId: string, type: string, costType: string, severity: string, location: string, cost): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      console.log('predictRepairCost ', tchekId, type, costType, severity, location, cost);
      parse.Cloud.run('predictRepairCost', {
        tchekId, type, costType, severity, location, cost
      }).then(response => resolve(response),
        error => reject(error));
    });
  }

  public async deleteDamage(id): Promise<any> {

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({ "isDeleted": true,"toSync":true, "_method": "PUT", "_ApplicationId": environment.parseID, "_JavaScriptKey": environment.parseKEY, "_SessionToken": parse.User.current().getSessionToken() });

    var requestOptions :RequestInit = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };

    fetch("https://apiclone.tchek.fr/private/classes/Damage/"+id, requestOptions)
      .then(response => response.text())
      .then(result => console.log(result))
      .catch(error => console.log('error', error));

  }
  public async updateDamage(damage): Promise<any> {

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    console.log(":damage.severityDamage",damage.severityDamage)
    var raw = JSON.stringify({ "location": damage.location,"sizeRange":damage.sizeRange,"severityDamage":damage.severityDamage,"type":damage.type, "_method": "PUT", "_ApplicationId": environment.parseID, "_JavaScriptKey": environment.parseKEY, "_SessionToken": parse.User.current().getSessionToken() });

    var requestOptions :RequestInit = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };

    fetch("https://apiclone.tchek.fr/private/classes/Damage/"+damage.id, requestOptions)
      .then(response => response.text())
      .then(result => console.log(result))
      .catch(error => console.log('error', error));

  }


  public async getModelIa(): Promise<ModelIa[]> {
    const query = new parse.Query('ModelIa')
    try {
      let result = await query.descending('createdAt').find()
      let Array: ModelIa[] = result.map<ModelIa>(o => new ModelIa(o))
      return Array
    } catch (e) {
      console.error(e);
      return undefined;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/service/damage.service.ts